"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The Pagination component
 */
var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _super.apply(this, arguments);
  }

  _createClass(Pagination, [{
    key: "_handleClick",
    value: function _handleClick(e, pageNumber) {
      e.preventDefault();
      this.props.onClick(pageNumber);
    }
    /**
     * Renders the ellipses that indicate there are more pages between
     * the first and/or last page
     */

  }, {
    key: "_renderEllipses",
    value: function _renderEllipses() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ellipses"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ellipse"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "ellipse"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "ellipse"
      }));
    }
    /**
     * Renders a single pagination item
     * @param {int} pageNumber - the page number this item links to
     * @param {bool} isCurrent - whether this page is the page we are
     * currently on
     */

  }, {
    key: "_renderPaginationItem",
    value: function _renderPaginationItem(pageNumber, isCurrent) {
      var _this = this;

      // Collect all the common props to both div and a tag here to keep code DRY
      var commonProps = {
        tabIndex: isCurrent ? '-1' : undefined,
        role: 'link',
        key: "pagination-item-".concat(pageNumber),
        'aria-label': "Page ".concat(pageNumber),
        'aria-disabled': isCurrent,
        className: isCurrent ? 'pagination-item current' : 'pagination-item'
      }; // if the page is the current page, render a div rather than a link

      if (isCurrent) {
        return /*#__PURE__*/_react.default.createElement("div", commonProps, pageNumber);
      } // otherwise we render a link with handlers for selection


      commonProps.onClick = function (e) {
        return _this._handleClick(e, pageNumber);
      };

      commonProps.href = this.props.linkPage(pageNumber);
      return /*#__PURE__*/_react.default.createElement("a", commonProps, pageNumber);
    }
    /**
     * Renders the row of pagination links that are displayed excluding
     * next and previous buttons. It dynamically calculates whether to
     * render ellipses or not between the first and last links
     */

  }, {
    key: "_renderPaginationItems",
    value: function _renderPaginationItems() {
      var _this$props = this.props,
          currentPage = _this$props.currentPage,
          numberOfPages = _this$props.numberOfPages,
          startFrom = _this$props.startFrom,
          pagesToDisplay = _this$props.pagesToDisplay;
      var paginationItems = [];

      var firstPageLink = this._renderPaginationItem(1, currentPage === 1); // If there is only one page we don't bother with the rest of the logic


      if (numberOfPages === 1) {
        return firstPageLink;
      } // we always allow user to access first page so we render it and push it on


      paginationItems.push(firstPageLink);
      var offset = Math.floor(pagesToDisplay / 2);
      var newStartFrom = 1;

      if (currentPage > offset && currentPage < numberOfPages - offset) {
        newStartFrom = currentPage - offset;
      } else if (currentPage >= numberOfPages - offset) {
        newStartFrom = Math.max(numberOfPages - pagesToDisplay, 1);
      }

      newStartFrom = startFrom || newStartFrom;
      /**
       * if we are starting from any page greater than 2, then
       * we should render ellipses to indicate the gap between
       * page 1 and the start page
       */

      if (newStartFrom >= 3) {
        paginationItems.push(this._renderEllipses());
      }
      /**
       * This handles an edge case where the user has selected start from 1, even though
       * we always render page 1 anyway
       */


      var begining = newStartFrom === 1 ? 2 : newStartFrom;
      /**
       * We do not let the row of page links end on a page greater than the
       * number of pages. Usually this would be handled by parent as the
       * contract indicates that they should be in charge of these types of
       * checks, but due to the above edgecase where they select startFrom 1
       * and we convert to startFrom === 2, there is a case where they may
       * not easily understand why it doesn't work.
       */

      var endOn = Math.min(begining + pagesToDisplay, numberOfPages); // render the center page links

      for (var i = begining; i < endOn; i++) {
        var paginationItem = this._renderPaginationItem(i, i === currentPage);

        paginationItems.push(paginationItem);
      }
      /**
       * End on corresponds to the actual page we wish to end on minus 1. So
       * if endOn = 15, then the rendered end will be 13 14 ... 16
       * Thus the only time we should render elipses is if the difference
       * between endOn and the number of pages is greater or equal to 1.
       */


      if (numberOfPages - endOn >= 1) {
        paginationItems.push(this._renderEllipses());
      }

      var lastPageLink = this._renderPaginationItem(numberOfPages, currentPage === numberOfPages);

      paginationItems.push(lastPageLink);
      return paginationItems;
    }
    /**
     * Renders the previous page arrow link
     * @param {int} currentPage - the page we are currently on
     */

  }, {
    key: "_renderPrevButton",
    value: function _renderPrevButton(currentPage) {
      var _this2 = this;

      // if you are on the first page you should not be able to press previous page button anymore
      var isFirstPage = currentPage === 1;
      var commonProps = {
        tabIndex: isFirstPage ? '-1' : undefined,
        role: 'link',
        key: 'previous-page',
        className: isFirstPage ? 'prev-arrow disabled' : 'prev-arrow',
        'aria-label': 'Previous Page',
        'aria-disabled': isFirstPage
      };

      if (isFirstPage) {
        return /*#__PURE__*/_react.default.createElement("div", commonProps);
      }

      commonProps.onClick = function (e) {
        return _this2._handleClick(e, currentPage - 1);
      };

      commonProps.href = this.props.linkPage(currentPage - 1);
      return /*#__PURE__*/_react.default.createElement("a", commonProps);
    }
    /**
     * Renders the next page arrow link
     * @param {int} currentPage - the page we are currently on
     */

  }, {
    key: "_renderNextButton",
    value: function _renderNextButton(currentPage, numberOfPages) {
      var _this3 = this;

      // if you are on the last page you should not be able to press next page button anymore
      var isLastPage = currentPage === numberOfPages;
      var commonProps = {
        tabIndex: isLastPage ? '-1' : undefined,
        role: 'link',
        key: 'next-page',
        'aria-label': 'Next Page',
        'aria-disabled': isLastPage,
        className: isLastPage ? 'next-arrow disabled' : 'next-arrow'
      };

      if (isLastPage) {
        return /*#__PURE__*/_react.default.createElement("div", commonProps);
      }

      commonProps.onClick = function (e) {
        return _this3._handleClick(e, currentPage + 1);
      };

      commonProps.href = this.props.linkPage(currentPage + 1);
      return /*#__PURE__*/_react.default.createElement("a", commonProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentPage = _this$props2.currentPage,
          numberOfPages = _this$props2.numberOfPages;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pagination"
      }, this._renderPrevButton(currentPage), this._renderPaginationItems(), this._renderNextButton(currentPage, numberOfPages));
    }
  }]);

  return Pagination;
}(_react.default.Component);

Pagination.defaultProps = {
  onClick: function onClick(index) {
    console.log("You selected page: ".concat(index));
  },
  linkPage: function linkPage() {
    return '#';
  },
  startFrom: null
};
Pagination.propTypes = {
  /**
   * onClick is a function that handles the clicking of a page, next or previous button.
   * It takes the index of the selected page as it's argument.
   */
  onClick: _propTypes.default.func,

  /**
   * pagesToDisplay is the number of pages to display apart from the first and last page.
   * This means that if you set pagesToDisplay={5}, then you will actually get 7 links
   * rendered. 1 ... 4 5 6 7 8 ... 16 for example.
   */
  pagesToDisplay: _propTypes.default.number.isRequired,

  /**
   * The page number to start your rendering from - so if you set:
   * pagesToDisplay={4}, startFrom={3}, numberOfPages={12}
   * you will see:
   * 1 ... 3 4 5 6 ... 12
   */
  startFrom: _propTypes.default.number,

  /**
   * The total number of pages available
   */
  numberOfPages: _propTypes.default.number.isRequired,

  /**
   * The currently selected page number
   */
  currentPage: _propTypes.default.number.isRequired,

  /**
   * Allows the user to right click and open in new tab
   * (index) => { return 'the/path/you/want/an/:index/to/go/to' }
   */
  linkPage: _propTypes.default.func
};
var _default = Pagination;
exports.default = _default;
//# sourceMappingURL=Pagination.js.map